// extracted by mini-css-extract-plugin
export default {"container":"CabecalhoPDF_container__SGx07","title":"CabecalhoPDF_title__ci4yR"};